import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { DividerComponent } from 'libs/shared/ui-common/src/lib/components/divider/divider.component';

import { FlowchartDragPaletteComponent } from '../flowchart-drag-palette/flowchart-drag-palette.component';

@Component({
  standalone: true,
  imports: [MatTabsModule, TranslocoModule, MatIconModule, TranslocoModule, DividerComponent, FlowchartDragPaletteComponent],
  selector: 'tt-guideline-flowchart-widget-sidebar',
  templateUrl: './flowchart-widget-sidebar.component.html',
  styleUrls: ['./flowchart-widget-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowchartWidgetSidebarComponent {}
